import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { getMyData } from '../../services/userService';
import CarouselPage from './carousel';
import LoginForm from './loginForm';
import Accenture from './img/Acc.png';
import TermsModal from './modal';
import './css/login.scss';

const PoweredBy = (
  <p className='poweredby'>
    <span>Powered By:&nbsp;</span>
    <a
      target='_blank'
      rel='noreferrer'
      href='https://www.accenture.com/us-en/services/ai-artificial-intelligence-index'
      style={{ color: '#000000' }}
    >
      Accenture Applied Intelligence
    </a>
  </p>
);

const LoginPage = (props) => {
  const [show, setShow] = useState(true);
  const [modal, setModal] = useState(false);

  useEffect(() => {
    async function getUser() {
      try {
        await getMyData();
        window.location = '/';
      } catch (err) {
        setShow(false);
      }
    }
    getUser();
  }, [props]);

  if (show) return null;
  return (
    <Row className='login-container'>
      <Col className='login-carousal'>
        <div className='login-carousal-container'>
          <CarouselPage />
        </div>
      </Col>
      <Col xs={12} md={5} lg={5} className='login-form'>
        <img className='d-block accenture' src={Accenture} alt='Accenture' />
        <h5 style={{ fontWeight: 600 }}>Welcome back to Watchtower</h5>
        <LoginForm {...props} />
        <p className='terms_privacy'>
          By clicking "Login", I agree that I have read and accepted the{' '}
          <span onClick={() => setModal(true)}>Legal Notice</span>
        </p>
        {PoweredBy}
      </Col>
      <TermsModal show={modal} onHide={() => setModal(false)} />
    </Row>
  );
};

export default LoginPage;
